var map = {
	"./BRP.svg": "709e",
	"./CoS-disabled.svg": "4877",
	"./CoS.svg": "2c00",
	"./analytics-disabled.svg": "bece",
	"./analytics.svg": "1811",
	"./badge.svg": "3386",
	"./bag-disabled.svg": "76ee",
	"./bag.svg": "cfb5",
	"./bar-chart.svg": "a762",
	"./bookmarks.svg": "b5ce",
	"./brp-disabled.svg": "2846",
	"./calendar-disabled.svg": "764b",
	"./calendar.svg": "eade",
	"./checks-disabled.svg": "13c7",
	"./checks.svg": "dee3",
	"./cup-disabled.svg": "2f7b",
	"./cup.svg": "dcce",
	"./directions.svg": "9d73",
	"./document-disabled.svg": "996c",
	"./document-verified-disabled.svg": "50a3",
	"./document-verified.svg": "acc9",
	"./document.svg": "a8e2",
	"./documents.svg": "c8b1",
	"./edit-disabled.svg": "e834",
	"./edit.svg": "4393",
	"./energy.svg": "44e4",
	"./entrance-disabled.svg": "86e6",
	"./entrance.svg": "b37a",
	"./envelope.svg": "233b",
	"./folder.svg": "477c",
	"./glasses-disabled.svg": "eb4b",
	"./glasses.svg": "73e4",
	"./heart-disabled.svg": "219d",
	"./heart.svg": "38da",
	"./help-circle-disabled.svg": "edb9",
	"./help-circle.svg": "103a",
	"./hourglass.svg": "8aa9",
	"./inbox-disabled.svg": "a581",
	"./inbox.svg": "012e",
	"./laptop.svg": "cf01",
	"./library-disabled.svg": "7ab2",
	"./library.svg": "ed35",
	"./like-disabled.svg": "cc36",
	"./like.svg": "e9a9",
	"./line-chart.svg": "0d98",
	"./medal-disabled.svg": "c895",
	"./medal.svg": "9a47",
	"./megafon-disabled.svg": "4aa8",
	"./megafon.svg": "3935",
	"./person-disabled.svg": "9e8c",
	"./person.svg": "60d8",
	"./pie-chart-disabled.svg": "b96a",
	"./pie-chart.svg": "6f8c",
	"./pin.svg": "cac5",
	"./plane-disabled.svg": "8db2",
	"./plane.svg": "6928",
	"./presentation-disabled.svg": "8941",
	"./presentation.svg": "acc7",
	"./puzzle-disabled.svg": "33b2",
	"./puzzle.svg": "3cec",
	"./repair-disabled.svg": "4a61",
	"./repair.svg": "7ab4",
	"./rocket-disabled.svg": "dfac",
	"./rocket.svg": "cadb",
	"./search-disabled.svg": "a424",
	"./search.svg": "fc4b",
	"./settings-disabled.svg": "6e30",
	"./settings.svg": "9e73",
	"./shield-disabled.svg": "c963",
	"./shield.svg": "23e5",
	"./smile-disabled.svg": "cd64",
	"./smile.svg": "345b",
	"./sparkle-disabled.svg": "3dbd",
	"./sparkle.svg": "561b",
	"./sync-disabled.svg": "28ec",
	"./sync.svg": "b287",
	"./web-disabled.svg": "4f27",
	"./web.svg": "5a45"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19ac";